module.exports = __webpack_public_path__ + "img/0499e6_1eccb179108b4c57a146e2cf0d834dd8_mv2.a97e75a5.webp";